export const toPersianNumber = (str='') => {
    const arabicToPersianMap = {
        '٠': '۰', '١': '۱', '٢': '۲', '٣': '۳', '٤': '۴', '٥': '۵', '٦': '۶', '٧': '۷', '٨': '۸', '٩': '۹'
    };

    const englishToPersianMap = {
        '0': '۰', '1': '۱', '2': '۲', '3': '۳', '4': '۴', '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹'
    };

    return str.toString()
        .replace(/[٠-٩]/g, (d) => arabicToPersianMap[d]) // Replace Arabic digits with Persian
        .replace(/\d/g, (d) => englishToPersianMap[d])   // Replace English digits with Persian
};

// Convert Persian digits to English digits
export const toEnglishNumber = (str) => {
    return str.toString().replace(/[۰-۹]/g, (d) => '0123456789'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)]);
};

// Filter out non-numeric characters except Persian and Arabic numbers
export const filterNonNumeric = (str) => {
    return str.replace(/[^۰-۹٠-٩0-9]/g, ''); // Keep only Persian, Arabic, and English digits
};
export const formatNumbers= (num) => {
    return new Intl.NumberFormat().format(num);
}
